import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class RuleCommand extends AbstractConfDataCommand {
  ruleId: number;
  confirmation?: boolean;
}